import {
  TRetailerSalesOrder,
  TSettlementMatrix,
  TSettlements,
  TTransactionMatrix,
  TTransactions,
  TgetSettlementDetailsParams,
  TgetSettlementListParams,
  TgetSettlementMatrixParams,
  TgetSettlementReportParams,
  TgetTransactionDetailsParams,
  TgetTransactionListParams,
  TgetTransactionMatrixParams,
  TgetTransationReportParams,
} from '../types/paymentsDashboard';
import { createTokenHeader } from '../utils/functions/headers';
import { emptySplitApi } from './emptySplitApi';

export const paymentsDashboardService = emptySplitApi
  .enhanceEndpoints({
    addTagTypes: ['settlementsList', 'transactionsList'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      uploadReversalsData: builder.mutation<void, FormData>(
        {
          query: (data) => {
            return {
              url: 'payouts/reversal-data/import',
              method: 'POST',
              data,
              headers: createTokenHeader(),
            };
          },
          invalidatesTags: [
            'settlementsList',
            'transactionsList',
          ],
        }
      ),
      getSettlementList: builder.query<
        TSettlements,
        TgetSettlementListParams
      >({
        query: (params) => ({
          method: 'GET',
          url: 'payouts/settlements',
          params,
        }),
        providesTags: ['settlementsList'],
      }),
      getSettlementMatrix: builder.query<
        TSettlementMatrix,
        TgetSettlementMatrixParams
      >({
        query: (params) => ({
          method: 'GET',
          url: 'payouts/settlements/counts',
          params,
        }),
      }),
      getSettlementReport: builder.query<
        { url?: string; status: number },
        TgetSettlementReportParams
      >({
        query: (params) => ({
          method: 'GET',
          url: 'payouts/settlement/export',
          params,
        }),
      }),
      getTransactionList: builder.query<
        TTransactions,
        TgetTransactionListParams
      >({
        query: (params) => ({
          method: 'GET',
          url: 'payouts/transactions',
          params,
        }),
      }),
      getTransactionMatrix: builder.query<
        TTransactionMatrix,
        TgetTransactionMatrixParams
      >({
        query: (params) => ({
          method: 'GET',
          url: 'payouts/transactions/counts',
          params,
        }),
      }),
      getTransactionReport: builder.query<
        { url?: string; status: number },
        TgetTransationReportParams
      >({
        query: ({ reportType, payload }) => ({
          method: 'POST',
          url: `export/sellerLedger/${reportType}`,
          data: payload,
        }),
      }),
      getSettlementUTRDetails: builder.query<
        TSettlements,
        TgetSettlementDetailsParams
      >({
        query: ({ settlementId, settlementPayload }) => ({
          method: 'GET',
          url: `payouts/settlements/${settlementId}`,
          params: settlementPayload,
        }),
      }),
      getTransactionDetails: builder.query<
        TTransactions,
        TgetTransactionDetailsParams
      >({
        query: ({
          orderId,
          paymentType,
          enterpriseId,
          transferType,
        }) => ({
          method: 'GET',
          url: `payouts/transactions/${orderId}/${paymentType}`,
          params: {
            enterpriseId,
            transferType,
          },
        }),
      }),
      getOrderDetails: builder.query<
        TRetailerSalesOrder,
        { orderId: number; enterpriseId: string | number }
      >({
        query: ({ orderId, enterpriseId }) => ({
          method: 'GET',
          url: `payouts/orders/${orderId}?enterpriseId=${enterpriseId}`,
        }),
      }),
    }),
  });

export const {
  useUploadReversalsDataMutation,
  useGetSettlementListQuery,
  useGetSettlementMatrixQuery,
  useLazyGetSettlementReportQuery,
  useLazyGetTransactionReportQuery,
  useGetTransactionListQuery,
  useGetTransactionMatrixQuery,
  useGetSettlementUTRDetailsQuery,
  useGetTransactionDetailsQuery,
  useGetOrderDetailsQuery,
} = paymentsDashboardService;
